import React from 'react';

const SB = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_50"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_50)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#025BC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 15H21V0L0 15Z"
        fill="#FCD715"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 15H21V2L2 15Z"
        fill="#24663A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.12201 5.658L4.50401 6L4.62201 5.276L4.12201 4.764L4.81201 4.658L5.12201 4L5.43201 4.658L6.12201 4.764L5.62201 5.276L5.74001 6L5.12201 5.658ZM3.12201 3.658L2.50401 4L2.62201 3.276L2.12201 2.764L2.81201 2.658L3.12201 2L3.43201 2.658L4.12201 2.764L3.62201 3.276L3.74001 4L3.12201 3.658ZM7.12201 3.658L6.50401 4L6.62201 3.276L6.12201 2.764L6.81201 2.658L7.12201 2L7.43201 2.658L8.12201 2.764L7.62201 3.276L7.74001 4L7.12201 3.658ZM7.12201 7.658L6.50401 8L6.62201 7.276L6.12201 6.764L6.81201 6.658L7.12201 6L7.43201 6.658L8.12201 6.764L7.62201 7.276L7.74001 8L7.12201 7.658ZM3.12201 7.658L2.50401 8L2.62201 7.276L2.12201 6.764L2.81201 6.658L3.12201 6L3.43201 6.658L4.12201 6.764L3.62201 7.276L3.74001 8L3.12201 7.658Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default SB;
